document.addEventListener('DOMContentLoaded', function () {
    const countUpElements = document.querySelectorAll('.wp-block-knightowl-blocks-count-up');

    function createObserver(element) {
        const offset = parseFloat(element.getAttribute('data-offset')) || 0;
        const delay = parseFloat(element.getAttribute('data-delay')) || 0;

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setTimeout(() => {
                        animateCountUp(entry.target);
                    }, delay);
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.5,
            rootMargin: `0px 0px ${offset}px 0px`
        });

        observer.observe(element);
    }

    countUpElements.forEach(element => {
        createObserver(element);
    });

    function animateCountUp(element) {
        const startNumber = parseFloat(element.getAttribute('data-count-start'));
        const endNumber = parseFloat(element.getAttribute('data-count-end'));
        const duration = parseFloat(element.getAttribute('data-duration'));
        const format = element.getAttribute('data-format');
        const prefix = element.getAttribute('data-prefix') || '';
        const suffix = element.getAttribute('data-suffix') || '';

        let currentNumber = startNumber;
        const range = endNumber - startNumber;
        const startTime = performance.now();

        function easeOutExpo(t, b, c, d) {
            return c * (-Math.pow(2, -10 * t / d) + 1) + b;
        }

        function formatNumber(number, format) {
            switch (format) {
                case 'comma':
                    number = Math.round(number).toLocaleString();
                    break;
                case 'decimal':
                    number = number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    break;
                case 'leading-zero':
                    const maxLength = endNumber.toString().length;
                    number = number.toFixed(0).padStart(maxLength, '0');
                    break;
                case 'abbreviations':
                    if (number >= 1000000) {
                        number = Math.floor(number / 1000000) + 'M';
                    } else if (number >= 1000) {
                        number = Math.floor(number / 1000) + 'K';
                    } else {
                        number = Math.floor(number);
                    }
                    break;
                default:
                    number = Math.round(number);
            }
            return number;
        }

        function updateNumber(timestamp) {
            const elapsedTime = timestamp - startTime;
            currentNumber = easeOutExpo(elapsedTime, startNumber, range, duration);

            if (elapsedTime >= duration) {
                element.innerText = prefix + formatNumber(endNumber, format) + suffix;
            } else {
                element.innerText = prefix + formatNumber(currentNumber, format) + suffix;
                requestAnimationFrame(updateNumber);
            }
        }

        requestAnimationFrame(updateNumber);
    }
});
